import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32d4c98e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container px-0 py-9"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 0,
  class: "bg-primary text-color-white"
}
const _hoisted_4 = ["id", "onClick"]
const _hoisted_5 = {
  fill: "none",
  height: "12",
  viewBox: "0 0 12 12",
  width: "12",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_6 = ["fill"]
const _hoisted_7 = ["fill"]
const _hoisted_8 = ["id"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, null, -1))
const _hoisted_10 = ["data-cy-id"]
const _hoisted_11 = {
  "data-title": "Cvr",
  style: {"width":"10%"}
}
const _hoisted_12 = {
  "data-title": "CompanyName",
  style: {"width":"25%"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = {
  id: "access-request-status-wrapper",
  class: "m-0"
}
const _hoisted_15 = {
  key: 0,
  id: "step-two-pending-notice",
  class: "access-action-pending"
}
const _hoisted_16 = {
  key: 1,
  id: "access-revoked-notice",
  class: "access-action-pending"
}
const _hoisted_17 = {
  key: 2,
  id: "access-denied-notice",
  class: "access-action-pending"
}
const _hoisted_18 = { style: {"width":"25%"} }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = {
  key: 0,
  "data-title": "EndData",
  style: {"width":"10%"}
}
const _hoisted_21 = {
  key: 1,
  "data-title": "EndData",
  style: {"width":"10%"}
}
const _hoisted_22 = {
  "data-title": "Calculations",
  style: {"width":"35%"}
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = {
  key: 0,
  class: "tab"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = {
  key: 0,
  class: "tab"
}
const _hoisted_27 = { "data-title": "Handlinger" }
const _hoisted_28 = { class: "overflow-menu overflow-menu--open-left" }
const _hoisted_29 = ["data-js-target"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  fill: "white",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#more-vert" })
], -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = ["id"]
const _hoisted_33 = { class: "overflow-list" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#people-alt" })
], -1))
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#people-alt" })
], -1))
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#trash-can" })
], -1))
const _hoisted_39 = {
  key: 1,
  id: "no-access-given-message",
  class: "container px-0 py-9"
}
const _hoisted_40 = {
  key: 2,
  class: "container px-0 py-9"
}
const _hoisted_41 = ["id"]
const _hoisted_42 = {
  key: 0,
  class: "bg-primary text-color-white"
}
const _hoisted_43 = ["id", "onClick"]
const _hoisted_44 = {
  fill: "none",
  height: "12",
  viewBox: "0 0 12 12",
  width: "12",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_45 = ["fill"]
const _hoisted_46 = ["fill"]
const _hoisted_47 = ["id"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, null, -1))
const _hoisted_49 = ["data-cy-id"]
const _hoisted_50 = {
  "data-title": "Cvr",
  style: {"width":"10%"}
}
const _hoisted_51 = {
  "data-title": "CompanyName",
  style: {"width":"25%"}
}
const _hoisted_52 = { style: {"width":"25%"} }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_54 = {
  key: 0,
  "data-title": "EndData",
  style: {"width":"10%"}
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = {
  key: 0,
  class: "badge badge-small"
}
const _hoisted_57 = {
  key: 1,
  class: "badge badge-small"
}
const _hoisted_58 = {
  key: 1,
  "data-title": "EndData",
  style: {"width":"10%"}
}
const _hoisted_59 = {
  "data-title": "Calculations",
  style: {"width":"35%"}
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_61 = {
  key: 0,
  class: "tab"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_63 = {
  key: 0,
  class: "tab"
}
const _hoisted_64 = { "data-title": "Handlinger" }
const _hoisted_65 = { class: "overflow-menu overflow-menu--open-left" }
const _hoisted_66 = ["data-js-target"]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  fill: "white",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#more-vert" })
], -1))
const _hoisted_68 = [
  _hoisted_67
]
const _hoisted_69 = ["id"]
const _hoisted_70 = { class: "overflow-list" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#people-alt" })
], -1))
const _hoisted_72 = ["onClick"]
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#trash-can" })
], -1))
const _hoisted_74 = { class: "modal-body" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AcceptModal = _resolveComponent("AcceptModal")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.accesses.some(access=>(access.expireDate>_ctx.currentDate && !access.revoked) || (!access.expireDate && !access.revoked)))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h1", null, [
            _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.givenAccessHeaderList" })
          ]),
          _createElementVNode("table", {
            id: _ctx.idWasGivenAccessToTableCurrent,
            "aria-label": "oversigt over dine adgang",
            class: "table w-percent-100"
          }, [
            _createElementVNode("thead", null, [
              (_ctx.tableHeaders)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeaders, (tableHeader) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (tableHeader.sortKey)
                          ? (_openBlock(), _createElementBlock("th", {
                              id: `table-header-${tableHeader.id}-${_ctx.idWasGivenAccessToTableCurrent}`,
                              key: tableHeader.sortKey,
                              class: "clickable",
                              scope: "col",
                              onClick: ($event: any) => (_ctx.sort(tableHeader.sortKey))
                            }, [
                              _createTextVNode(_toDisplayString(tableHeader.headline) + " ", 1),
                              (_openBlock(), _createElementBlock("svg", _hoisted_5, [
                                _createElementVNode("path", {
                                  fill: _ctx.currentSort === tableHeader.sortKey && _ctx.currentSortDirection === 'asc' ? 'white' : '',
                                  "clip-rule": "evenodd",
                                  d: "M9.99419 4.75003L6.00003 0.755859L2.00586 4.75003H9.99419Z",
                                  "fill-rule": "evenodd",
                                  stroke: "white"
                                }, null, 8, _hoisted_6),
                                _createElementVNode("path", {
                                  fill: _ctx.currentSort === tableHeader.sortKey && _ctx.currentSortDirection === 'desc' ? 'white' : '',
                                  "clip-rule": "evenodd",
                                  d: "M2.00586 7.25003L6.00003 11.2442L9.99419 7.25003H2.00586Z",
                                  "fill-rule": "evenodd",
                                  stroke: "white"
                                }, null, 8, _hoisted_7)
                              ]))
                            ], 8, _hoisted_4))
                          : _createCommentVNode("", true),
                        (!tableHeader.sortKey)
                          ? (_openBlock(), _createElementBlock("th", {
                              id: `table-header-${tableHeader.id}-${_ctx.idWasGivenAccessToTableCurrent}`,
                              key: tableHeader.id,
                              class: "clickable",
                              scope: "col"
                            }, _toDisplayString(tableHeader.headline), 9, _hoisted_8))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 256)),
                    _hoisted_9
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedAccesses.filter(x=>(x.expireDate>_ctx.currentDate && !x.revoked) || (!x.expireDate && !x.revoked)), (acc) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: acc.id,
                  "data-cy-id": acc.vatIdSource
                }, [
                  _createElementVNode("td", _hoisted_11, _toDisplayString(acc.privateSource ? _ctx.privateUserText : acc.vatId), 1),
                  _createElementVNode("td", _hoisted_12, [
                    _createTextVNode(_toDisplayString(acc.privateSource ? acc.nameSource : acc.companyNameSource), 1),
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      (_ctx.hasStep2Pending(acc))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.hasStep2Pending(acc) ? this.getContentfulString('thirdparty.step2.notification.access-awaiting-request-response') : ''), 1))
                        : _createCommentVNode("", true),
                      (_ctx.hasRevokedAccess(acc))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.hasRevokedAccess(acc) ? this.getContentfulString('thirdparty.step2.notification.access-revoked') : ''), 1))
                        : _createCommentVNode("", true),
                      (_ctx.compAHasRejectedAccess(acc))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.compAHasRejectedAccess(acc) ? this.getContentfulString('thirdparty.step2.notification.access-request-denied') : ''), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_18, [
                    _createTextVNode(_toDisplayString(acc.contantPersonName) + " ", 1),
                    _hoisted_19,
                    _createTextVNode(" " + _toDisplayString(acc.contactPersonEmail), 1)
                  ]),
                  (acc.expireDate)
                    ? _withDirectives((_openBlock(), _createElementBlock("td", _hoisted_20, null, 512)), [
                        [_directive_dompurify_html, _ctx.formatDate(acc.expireDate)]
                      ])
                    : (_openBlock(), _createElementBlock("td", _hoisted_21)),
                  _createElementVNode("td", _hoisted_22, [
                    _createElementVNode("strong", null, [
                      _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.draft" })
                    ]),
                    _createTextVNode(),
                    _hoisted_23,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(acc.calculationInfoList, (calc) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: calc.calculationId
                      }, [
                        (calc.isKladde)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(`${calc.calculationName}`), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _createElementVNode("strong", null, [
                      _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.completed" })
                    ]),
                    _createTextVNode(),
                    _hoisted_25,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(acc.calculationInfoList, (calc) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: calc.calculationId
                      }, [
                        (!calc.isKladde)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(`${calc.calculationName}`), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("td", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("button", {
                        class: _normalizeClass([`button-overflow-menu`, "button-overflow-menu js-dropdown"]),
                        "data-js-target": `access-${acc.id}-actions-overflow`,
                        "aria-expanded": "false",
                        "aria-haspopup": "true",
                        "aria-label": "handlinger"
                      }, _hoisted_31, 8, _hoisted_29),
                      _createElementVNode("div", {
                        id: `access-${acc.id}-actions-overflow`,
                        "aria-hidden": "true",
                        class: "overflow-menu-inner"
                      }, [
                        _createElementVNode("ul", _hoisted_33, [
                          _createElementVNode("li", null, [
                            (_ctx.hasStep2Access(acc))
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  class: "edit-button",
                                  to: "/overview",
                                  onClick: ($event: any) => (_ctx.useAccess(acc))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_SimpleText, { "text-key": "access.utilize-access" }),
                                    _hoisted_34
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("li", null, [
                            (_ctx.hasStep1Access(acc) ||
                  _ctx.hasRevokedAccess(acc) ||
                  _ctx.hasAccessDeletedCompA(acc) ||
                  _ctx.compAHasRejectedAccess(acc))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "access-action-pending",
                                  onClick: ($event: any) => (_ctx.requestAccess(acc))
                                }, [
                                  _createVNode(_component_SimpleText, { "text-key": "access.request-access" }),
                                  _hoisted_36
                                ], 8, _hoisted_35))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("li", null, [
                            (!_ctx.hasRevokedAccess(acc))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "delete-button",
                                  onClick: ($event: any) => (_ctx.confirmDeleteAccess(acc))
                                }, [
                                  _createVNode(_component_SimpleText, { "text-key": "access.remove-access" }),
                                  _hoisted_38
                                ], 8, _hoisted_37))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ], 8, _hoisted_32)
                    ])
                  ])
                ], 8, _hoisted_10))
              }), 128))
            ])
          ], 8, _hoisted_2)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createElementVNode("p", null, [
            _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.noGivenAccess" })
          ])
        ])),
    (_ctx.accesses.filter(x=>x.expireDate<=_ctx.currentDate && !x.revoked).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
          _createElementVNode("h1", null, [
            _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.expiredAccessTableHeader" })
          ]),
          _createElementVNode("table", {
            id: _ctx.idWasGivenAccessToTableExpired,
            "aria-label": "oversigt over dine adgang",
            class: "table w-percent-100"
          }, [
            _createElementVNode("thead", null, [
              (_ctx.tableHeaders)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_42, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeaders, (tableHeader) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (tableHeader.sortKey)
                          ? (_openBlock(), _createElementBlock("th", {
                              id: `table-header-${tableHeader.id}-${_ctx.idWasGivenAccessToTableExpired}`,
                              key: tableHeader.sortKey,
                              class: "clickable",
                              scope: "col",
                              onClick: ($event: any) => (_ctx.sort(tableHeader.sortKey))
                            }, [
                              _createTextVNode(_toDisplayString(tableHeader.headline) + " ", 1),
                              (_openBlock(), _createElementBlock("svg", _hoisted_44, [
                                _createElementVNode("path", {
                                  fill: _ctx.currentSort === tableHeader.sortKey && _ctx.currentSortDirection === 'asc' ? 'white' : '',
                                  "clip-rule": "evenodd",
                                  d: "M9.99419 4.75003L6.00003 0.755859L2.00586 4.75003H9.99419Z",
                                  "fill-rule": "evenodd",
                                  stroke: "white"
                                }, null, 8, _hoisted_45),
                                _createElementVNode("path", {
                                  fill: _ctx.currentSort === tableHeader.sortKey && _ctx.currentSortDirection === 'desc' ? 'white' : '',
                                  "clip-rule": "evenodd",
                                  d: "M2.00586 7.25003L6.00003 11.2442L9.99419 7.25003H2.00586Z",
                                  "fill-rule": "evenodd",
                                  stroke: "white"
                                }, null, 8, _hoisted_46)
                              ]))
                            ], 8, _hoisted_43))
                          : _createCommentVNode("", true),
                        (!tableHeader.sortKey)
                          ? (_openBlock(), _createElementBlock("th", {
                              id: `table-header-${tableHeader.id}-${_ctx.idWasGivenAccessToTableExpired}`,
                              key: tableHeader.id,
                              class: "clickable",
                              scope: "col"
                            }, _toDisplayString(tableHeader.headline), 9, _hoisted_47))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 256)),
                    _hoisted_48
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedAccesses.filter(x=>x.expireDate<=_ctx.currentDate && !x.revoked), (acc) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: acc.id,
                  "data-cy-id": acc.vatIdSource
                }, [
                  _createElementVNode("td", _hoisted_50, _toDisplayString(acc.privateSource ? _ctx.privateUserText : acc.vatId), 1),
                  _createElementVNode("td", _hoisted_51, [
                    _createTextVNode(_toDisplayString(acc.privateSource ? acc.nameSource : acc.companyNameSource) + " ", 1),
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(acc.revoked ? _ctx.accessRejectedText + ' ' + _ctx.formatDate(acc.revokedDate) : ''), 1)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_52, [
                    _createTextVNode(_toDisplayString(acc.contantPersonName) + " ", 1),
                    _hoisted_53,
                    _createTextVNode(" " + _toDisplayString(acc.contactPersonEmail), 1)
                  ]),
                  (acc.expireDate)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_54, [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(acc.expireDate)) + " ", 1),
                        _hoisted_55,
                        (!acc.revoked)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_56, [
                              _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.expiredTag" })
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_57, [
                              _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.rejectedTag" })
                            ]))
                      ]))
                    : (_openBlock(), _createElementBlock("td", _hoisted_58)),
                  _createElementVNode("td", _hoisted_59, [
                    _createElementVNode("strong", null, [
                      _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.draft" })
                    ]),
                    _createTextVNode(),
                    _hoisted_60,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(acc.calculationInfoList, (calc) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: calc.calculationId
                      }, [
                        (calc.isKladde)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(`${calc.calculationName}`), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _createElementVNode("strong", null, [
                      _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.completed" })
                    ]),
                    _createTextVNode(),
                    _hoisted_62,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(acc.calculationInfoList, (calc) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: calc.calculationId
                      }, [
                        (!calc.isKladde)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString(`${calc.calculationName}`), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("td", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("button", {
                        class: _normalizeClass([`button-overflow-menu`, "button-overflow-menu js-dropdown"]),
                        "data-js-target": `access-${acc.id}-actions-overflow`,
                        "aria-expanded": "false",
                        "aria-haspopup": "true",
                        "aria-label": "handlinger"
                      }, _hoisted_68, 8, _hoisted_66),
                      _createElementVNode("div", {
                        id: `access-${acc.id}-actions-overflow`,
                        "aria-hidden": "true",
                        class: "overflow-menu-inner"
                      }, [
                        _createElementVNode("ul", _hoisted_70, [
                          _createElementVNode("li", null, [
                            (!acc.revoked && !acc.expireDate>_ctx.currentDate)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  class: "edit-button",
                                  to: "/overview",
                                  onClick: ($event: any) => (_ctx.useAccess(acc))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_SimpleText, { "text-key": "access.utilize-access" }),
                                    _hoisted_71
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("button", {
                              class: "delete-button",
                              onClick: ($event: any) => (_ctx.confirmDeleteAccess(acc))
                            }, [
                              _createVNode(_component_SimpleText, { "text-key": "access.remove-access" }),
                              _hoisted_73
                            ], 8, _hoisted_72)
                          ])
                        ])
                      ], 8, _hoisted_69)
                    ])
                  ])
                ], 8, _hoisted_49))
              }), 128))
            ])
          ], 8, _hoisted_41)
        ]))
      : _createCommentVNode("", true),
    (_ctx.accessToDelete.id && _ctx.accessToDelete.id > 0)
      ? (_openBlock(), _createBlock(_component_AcceptModal, {
          key: 3,
          "value-object": _ctx.accessToDelete,
          "title-key": 'thirdparty.has-access-to.delete-modal.title',
          "buttons-disabled": _ctx.disableDeleteModalButtons,
          "button-ok-text-key": 'thirdparty.has-access-to.delete-modal.button.ok',
          "button-reject-text-key": 'thirdparty.has-access-to.delete-modal.button.cancel',
          onSelectOk: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteAccess($event))),
          onSelectReject: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetAccessToDelete()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_SimpleText, {
                    "text-key": this.revokeContentfulKey
                  }, null, 8, ["text-key"])
                ]),
                _hoisted_75,
                _hoisted_76,
                _createTextVNode(_toDisplayString(_ctx.accessToDelete.privateSource ? _ctx.accessToDelete.nameSource : _ctx.accessToDelete.companyNameSource) + " (CVR=" + _toDisplayString(_ctx.accessToDelete.privateSource ? _ctx.privateUserText : _ctx.accessToDelete.vatId) + ")", 1),
                _hoisted_77,
                _hoisted_78,
                _createVNode(_component_SimpleText, { "text-key": 'thirdparty.was-given-access-to.delete-modal.text2' }, null, 8, ["text-key"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["value-object", "title-key", "buttons-disabled", "button-ok-text-key", "button-reject-text-key"]))
      : _createCommentVNode("", true)
  ], 64))
}